






















































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { setMetaData, timeFormat } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import {
  GetOptionsForAttendanceReportReq,
  ListGroupAttendanceReq
} from "@/pbjs/external/user/user_pb";
import { client } from "@/api/index";
@Component({
  name: "PerformanceManagement"
})
export default class PerformanceManagement extends Vue {
  @Provide() private searchForm: any = {
    dates: [],
    roleValue: null
  };
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private updatedTime: any = "";
  @Provide() private resultData: any = [];
  @Provide() private roleOptions: any = [];
  @Provide() private totalData: any = [];

  get roleData(): any {
    return this.$store.getters.ROLE_INFO;
  } //  角色
  private created() {
    this.getOptionsForAttendanceReport();
    // this.getAttendanceReport();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getExtenList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getExtenList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getExtenList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getExtenList();
  }

  private isNull(val: any): boolean {
    if (val) {
      return false;
    }
    return true;
  }
  // lee 获取列表
  private async getExtenList() {}

  private getOptionsForAttendanceReport() {
    let getOptionsForAttendanceReportFunc: any = (data: any) => {
      this.roleOptions = data.usergroupsList;
    };
    let request: any = new GetOptionsForAttendanceReportReq();
    request.setCommonin(setCommon());
    client.getOptionsForAttendanceReport(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          handleResponse(data, getOptionsForAttendanceReportFunc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private getAttendanceReport() {
    let getAttendanceReportFunc: any = (data: any) => {
      this.resultData = data.attendancereportformList;
      this.totalData = data.attendancereportsummary;
    };
    let request: any = new ListGroupAttendanceReq();
    request.setCommonin(setCommon());
    request.setUnderwhichusergroupsList(this.searchForm.roleValue);
    request.setDateList(this.searchForm.dates);
    client.listGroupAttendance(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          handleResponse(data, getAttendanceReportFunc);
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }
}
